// ✅ Nouveau CourseDetails.js avec design onglets amélioré et chargement attractif + navigation & quiz intégré
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Tabs, Spin } from "antd";
import {
  ReadOutlined,
  BookOutlined
} from "@ant-design/icons";
import CourseOverview from "./CourseOverview";
import CourseContent from "./CourseContent";
import courseService from "../../services/course.service";
import authHeader from "../../services/auth-header";
import API_BASE from "../../config/apiConfig";
import CourseContentViewer from "./CourseFullViewer";
import CourseFullViewer from "./CourseFullViewer";

const CourseDetails = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState(null);
  const [imageUrl, setImageUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [completedSubjects, setCompletedSubjects] = useState([]); // ✅ suivi quiz validé
  const handleMarkCompleted = (subjectId) => {
    setCompletedSubjects((prev) => ({ ...prev, [subjectId]: true }));
  };

  const API_PROXY_URL = `${API_BASE}/images/proxy`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const courseData = await courseService.getCourseDetails(id);
        setCourse(courseData);

        const imageBlobUrl = await fetchImage(courseData.image);
        setImageUrl(imageBlobUrl);

        const subjectList = await courseService.getSubjectsByCourse(id);
        setSubjects(subjectList);
        if (subjectList.length > 0) {
          setSelectedSubjectId(subjectList[0].id);
        }
      } catch (err) {
        console.error("Erreur lors du chargement :", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const fetchImage = async (url) => {
    try {
      const response = await fetch(`${API_PROXY_URL}?url=${encodeURIComponent(url)}`, {
        headers: authHeader()
      });

      if (!response.ok) throw new Error("Image non récupérée");
      const blob = await response.blob();
      return URL.createObjectURL(blob);
    } catch (err) {
      console.warn("Erreur image :", err);
      return "/default-image.png";
    }
  };

  const handleSelectSubject = (subject) => {
    setSelectedSubjectId(subject.id);
  };

  const handleMarkAsCompleted = (subjectId) => {
    if (!completedSubjects.includes(subjectId)) {
      setCompletedSubjects([...completedSubjects, subjectId]);
    }
  };

  const goToNext = () => {
    const index = subjects.findIndex((s) => s.id === selectedSubjectId);
    if (index >= 0 && index < subjects.length - 1) {
      setSelectedSubjectId(subjects[index + 1].id);
    }
  };

  const goToPrevious = () => {
    const index = subjects.findIndex((s) => s.id === selectedSubjectId);
    if (index > 0) {
      setSelectedSubjectId(subjects[index - 1].id);
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "75vh"
        }}
      >
        <div style={{ textAlign: "center" }}>
          <Spin size="large" style={{ color: "#1890ff" }} />
          <div style={{ marginTop: 10, color: "#1890ff" }}>Chargement du cours...</div>
        </div>
      </div>
    );
  }

  return (
    <Tabs defaultActiveKey="1" style={{ padding: "10px 20px" }}>
      <Tabs.TabPane
        key="1"
        tab={
          <span>
            <ReadOutlined style={{ color: "#1890ff" }} /> Aperçu
          </span>
        }
      >
        <CourseOverview course={course} imageUrl={imageUrl} />
      </Tabs.TabPane>

     
      <Tabs.TabPane key="2" tab={<span><BookOutlined /> Contenu du cours</span>}>
        <CourseFullViewer  courseId={id}  ></CourseFullViewer>
      </Tabs.TabPane>

    </Tabs>
  );
};

export default CourseDetails;
